<app-tool-bar 
  [title]="'Manage Packages & Add-ons'" 
  [iconName]="'pi-box'">
</app-tool-bar>


<div class="p-4 overflow-auto h-[85vh]">
  <p-tabView [(activeIndex)]="activeTab" (onChange)="onTabChange($event)">
    
    <p-tabPanel header="Packages" leftIcon="pi pi-box">
      <app-package-list
        (openPackageForm)="openCreatePackage()"
        (editPackage)="openEditPackage($event)"
        (deletePackage)="deletePackage($event)">
      </app-package-list>
    </p-tabPanel>

    <p-tabPanel header="Add-ons" leftIcon="pi pi-plus-circle">
      <app-addon-list
        (openAddon)="openCreateAddon()"
        (editAddon)="openEditAddon($event)"
        (deleteAddon)="deleteAddon($event)">
      </app-addon-list>
    </p-tabPanel>

    <p-tabPanel header="Assign Package" leftIcon="pi pi-user-plus">
       <app-client-package 
        (openClientPackage)="openClientPackage()"
        (editClientPackage)="editClientPackage($event)"
        (deleteClientPackage)="deleteAddon($event)">
       ></app-client-package>
    </p-tabPanel>

    <p-tabPanel header="Assign Add-on" leftIcon="pi pi-shopping-cart">
      
       <app-client-addons 
        (openAssignAddon)="openAssignAddon()"
        (editAssignAddon)="editAssignAddon($event)"
        (deleteAssignAddon)="deleteAddon($event)">
       ></app-client-addons>
      
      
    </p-tabPanel>

  </p-tabView>
</div>

<ng-container *ngIf="showPackageFormModal">
<app-package-form
  [visible]="showPackageFormModal"
  [packageData]="selectedPackage"
  (close)="closePackageForm()"
  [featuresList]="featuresList"
  (reload)="reloadPackages()">
</app-package-form>
</ng-container>

<ng-container *ngIf="showAddonFormModal">
<app-addon-form
  [visible]="showAddonFormModal"
  [addonData]="selectedAddon"
  [featuresList]="featuresList"
  (close)="closeAddonForm()"
  (reload)="reloadAddons()">
</app-addon-form>
</ng-container>

<ng-container *ngIf="showAssignPackageModal">
<app-assign-package
  [visible]="showAssignPackageModal"
  [clientPackage]="selectedClientPackage"
  (close)="closeAssignPackage()"
  (reload)="reloadAddons()">
</app-assign-package>
</ng-container>


 <app-assign-addon
  [visible]="showAssignAddonModal"
  [clientAddon]="selectedClientAddon"
  (close)="closeAssignAddon()"
  (reload)="reloadAddons()">
</app-assign-addon>  
<p-confirmDialog></p-confirmDialog> 





<ng-container *ngIf="showDeletePackage">
  <p-dialog [(visible)]="showDeletePackage" [modal]="true" [style]="{width: '40rem'}" [closable]="false">
    <div class="flex items-center justify-center dialog-header relative">
      Delete Package

      <div class="absolute right-2">
        <button (click)="showDeletePackage = false" class="outline-none p-5">
          <i class="pi pi-times"></i>
        </button>
      </div>
    </div>

    <div class="dialog-content p-5">

      <div class="text-center font-medium text-lg">
        Are you sure you want to delete the package:
        <span class="font-bold text-red-500">
          {{ selectedPackage.package_name }}?
        </span>
      </div>

      <div class="flex gap-4 mt-7 justify-end">
        <p-button label="Cancel" severity="secondary" variant="outlined" (click)="showDeletePackage = false">
        </p-button>

        <p-button label="Delete" severity="danger" icon="pi pi-trash" (click)="deletePackageConfirm()" [loading]="isDeleting"
          [disabled]="isDeleting">
        </p-button>
      </div>

    </div>

  </p-dialog>
</ng-container>

<ng-container *ngIf="showDeleteAddon">
  <p-dialog [(visible)]="showDeleteAddon" [modal]="true" [style]="{width: '40rem'}" [closable]="false">
    <div class="flex items-center justify-center dialog-header relative">
      Delete Add-on

      <div class="absolute right-2">
        <button (click)="showDeleteAddon = false" class="outline-none p-5">
          <i class="pi pi-times"></i>
        </button>
      </div>
    </div>

    <div class="dialog-content p-5">

      <div class="text-center font-medium text-lg">
        Are you sure you want to delete the add-on:
        <span class="font-bold text-red-500">
          {{ selectedAddon.name }}?
        </span>
      </div>

      <div class="flex gap-4 mt-7 justify-end">
        <p-button label="Cancel" severity="secondary" variant="outlined" (click)="showDeleteAddon = false">
        </p-button>

        <p-button label="Delete" severity="danger" icon="pi pi-trash" (click)="deleteAddonConfirm()" [loading]="isDeleting"
          [disabled]="isDeleting">
        </p-button>
      </div>

    </div>

  </p-dialog>
</ng-container>